import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HisSearchResponse } from "models/his/hisSearchResponse";
import { HisSearchRequest } from "models/his/models";
import { Observable } from "rxjs";
import { ReportExportRequest } from "../../models/his/reportExportRequest";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class HisDataService {
  private apiUrl: string;

  constructor(private http: HttpClient, private config: ConfigurationService) {
    this.apiUrl = config.getConfig().apiUrl;

    if (
      this.config.getConfig().isLocal &&
      this.config.getConfig().localEndpoints.hisAdmissionUrl
    ) {
      this.apiUrl =
        this.config.getConfig().localEndpoints.hisAdmissionUrl + "/his";
    } else {
      this.apiUrl = this.config.getConfig().hisAdmissionUrl + "/his";
    }
  }

  public searchHisData(
    type: String,
    hisSearchRequest: HisSearchRequest
  ): Observable<HisSearchResponse> {
    let requestUrl = `${this.apiUrl}/report/${type}`;
    const params = new URLSearchParams();
    if (hisSearchRequest.limit)
      params.append("limit", hisSearchRequest.limit.toString());
    if (hisSearchRequest.from) params.append("from", hisSearchRequest.from);
    if (hisSearchRequest.to) params.append("to", hisSearchRequest.to);
    if (hisSearchRequest.type) params.append("type", hisSearchRequest.type);
    if (hisSearchRequest.patient)
      params.append("patient", encodeURIComponent(hisSearchRequest.patient));
    if (hisSearchRequest.sort) params.append("sort", hisSearchRequest.sort);
    if (hisSearchRequest.order) params.append("order", hisSearchRequest.order);
    if (hisSearchRequest.page)
      params.append("page", hisSearchRequest.page.toString());

    if (params.toString()) {
      requestUrl += `?${params.toString()}`;
    }

    return this.http.get<HisSearchResponse>(requestUrl);
  }

  public getFile(
    request: Array<ReportExportRequest>,
    systemAdminToggle: boolean,
    hisExportV1: boolean,
    force: boolean = false,
    skipList: number[] = []
  ) {
    let requestUrl = `${this.apiUrl}/report/generate`;
    const params = new URLSearchParams();

    if (force) {
      params.append("force", "true");
    }
    skipList.forEach((skip) => {
      params.append("skipList", skip.toString());
    });
    params.append("systemAdminToggle", String(systemAdminToggle));
    params.append("hisExportV1", String(hisExportV1));

    if (params.toString()) {
      requestUrl += `?${params.toString()}`;
    }

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http.post(requestUrl, request, {
      headers,
      responseType: "blob" as "json",
      observe: "response",
    });
  }

  public getAllFile(
    hisSearchDetails: HisSearchRequest,
    systemAdminToggle: boolean,
    hisExportV1: boolean,
    force: boolean = false,
    skipList: number[] = []
  ) {
    let requestUrl = `${this.apiUrl}/report/generateAll`;
    const params = new URLSearchParams();

    if (force) {
      params.append("force", "true");
    }
    skipList.forEach((skip) => {
      params.append("skipList", skip.toString());
    });
    params.append("systemAdminToggle", String(systemAdminToggle));
    params.append("hisExportV1", String(hisExportV1));

    if (params.toString()) {
      requestUrl += `?${params.toString()}`;
    }

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http.post(requestUrl, hisSearchDetails, {
      headers,
      responseType: "blob" as "json",
      observe: "response",
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/his-service/his-data-service.ts